import { Draft, produce } from 'immer';

import LoadingStatus from '@libs/loading-status';

import {
  DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_FAILURE,
  DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_REQUEST,
  DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_SUCCESS,
  DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_FAILURE,
  DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_REQUEST,
  DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_SUCCESS,
  DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_FAILURE,
  DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_REQUEST,
  DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_SUCCESS,
  DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_FAILURE,
  DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_REQUEST,
  DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_SUCCESS,
  DOCUMENT_PROGRESS__REQUEST_CANCEL_FAILURE,
  DOCUMENT_PROGRESS__REQUEST_CANCEL_REQUEST,
  DOCUMENT_PROGRESS__REQUEST_CANCEL_SUCCESS,
  DOCUMENT_PROGRESS__SIGNING_REMIND_FAILURE,
  DOCUMENT_PROGRESS__SIGNING_REMIND_REQUEST,
  DOCUMENT_PROGRESS__SIGNING_REMIND_SUCCESS,
} from '@app/store/actionTypes';
import { DocumentProgressAction } from '@app/store/documentProgress/actions';
import DocumentProgressType from '@app/store/documentProgress/DocumentProgressType';

type DocumentProgressLoadingStatusState = Record<DocumentProgressType, LoadingStatus>;

const initialState: DocumentProgressLoadingStatusState = {
  BULK_EXPIRY_DATE_CHANGE: LoadingStatus.IDLE,
  BULK_REQUEST_CANCEL: LoadingStatus.IDLE,
  BULK_SIGNING_REMIND: LoadingStatus.IDLE,
  EXPIRY_DATE_CHANGE: LoadingStatus.IDLE,
  REQUEST_CANCEL: LoadingStatus.IDLE,
  SIGNING_REMIND: LoadingStatus.IDLE,
};

const reducer = produce(
  (draft: Draft<DocumentProgressLoadingStatusState>, action: DocumentProgressAction) => {
    switch (action.type) {
      case DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_REQUEST: {
        draft.BULK_EXPIRY_DATE_CHANGE = LoadingStatus.PENDING;
        return draft;
      }
      case DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_SUCCESS: {
        draft.BULK_EXPIRY_DATE_CHANGE = LoadingStatus.SUCCEEDED;
        return draft;
      }
      case DOCUMENT_PROGRESS__BULK_EXPIRY_DATE_CHANGE_FAILURE: {
        draft.BULK_EXPIRY_DATE_CHANGE = LoadingStatus.FAILED;
        return draft;
      }
      case DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_REQUEST: {
        draft.BULK_REQUEST_CANCEL = LoadingStatus.PENDING;
        return draft;
      }
      case DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_SUCCESS: {
        draft.BULK_REQUEST_CANCEL = LoadingStatus.SUCCEEDED;
        return draft;
      }
      case DOCUMENT_PROGRESS__BULK_REQUEST_CANCEL_FAILURE: {
        draft.BULK_REQUEST_CANCEL = LoadingStatus.FAILED;
        return draft;
      }
      case DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_REQUEST: {
        draft.BULK_SIGNING_REMIND = LoadingStatus.PENDING;
        return draft;
      }
      case DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_SUCCESS: {
        draft.BULK_SIGNING_REMIND = LoadingStatus.SUCCEEDED;
        return draft;
      }
      case DOCUMENT_PROGRESS__BULK_SIGNING_REMIND_FAILURE: {
        draft.BULK_SIGNING_REMIND = LoadingStatus.FAILED;
        return draft;
      }
      case DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_REQUEST: {
        draft.EXPIRY_DATE_CHANGE = LoadingStatus.PENDING;
        return draft;
      }
      case DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_SUCCESS: {
        draft.EXPIRY_DATE_CHANGE = LoadingStatus.SUCCEEDED;
        return draft;
      }
      case DOCUMENT_PROGRESS__EXPIRY_DATE_CHANGE_FAILURE: {
        draft.EXPIRY_DATE_CHANGE = LoadingStatus.FAILED;
        return draft;
      }
      case DOCUMENT_PROGRESS__REQUEST_CANCEL_REQUEST: {
        draft.REQUEST_CANCEL = LoadingStatus.PENDING;
        return draft;
      }
      case DOCUMENT_PROGRESS__REQUEST_CANCEL_SUCCESS: {
        draft.REQUEST_CANCEL = LoadingStatus.SUCCEEDED;
        return draft;
      }
      case DOCUMENT_PROGRESS__REQUEST_CANCEL_FAILURE: {
        draft.REQUEST_CANCEL = LoadingStatus.FAILED;
        return draft;
      }
      case DOCUMENT_PROGRESS__SIGNING_REMIND_REQUEST: {
        draft.SIGNING_REMIND = LoadingStatus.PENDING;
        return draft;
      }
      case DOCUMENT_PROGRESS__SIGNING_REMIND_SUCCESS: {
        draft.SIGNING_REMIND = LoadingStatus.SUCCEEDED;
        return draft;
      }
      case DOCUMENT_PROGRESS__SIGNING_REMIND_FAILURE: {
        draft.SIGNING_REMIND = LoadingStatus.FAILED;
        return draft;
      }
      default:
        return draft;
    }
  },
  initialState
);

export default reducer;
